import * as constants from './constants';

/* Get project skus */
export const getSkus = (projectId) => ({
  type: constants.GET_SKUS,
  projectId
});

export const getSkusSuccess = (projectId, skus) => ({
  type: constants.GET_SKUS_SUCCESS,
  projectId,
  skus
});

export const getSkusError = (projectId, error) => ({
  type: constants.GET_SKUS_ERROR,
  projectId,
  error
});

/* Create order */
export const createOrder = (projectId, skus, paymentMethodId, actions) => ({
  type: constants.CREATE_ORDER,
  projectId,
  skus,
  paymentMethodId,
  actions
});

export const createOrderSuccess = (projectId, order) => ({
  type: constants.CREATE_ORDER_SUCCESS,
  projectId,
  order
});

export const createOrderError = (projectId, error) => ({
  type: constants.CREATE_ORDER_ERROR,
  projectId,
  error
});

/* Purchase order */
export const purchaseOrder = (
  projectId,
  paymentIntentId,
  stripeMethods,
  actions
) => ({
  type: constants.PURCHASE_ORDER,
  projectId,
  paymentIntentId,
  stripeMethods,
  actions
});

export const purchaseOrderSuccess = (projectId, credits) => ({
  type: constants.PURCHASE_ORDER_SUCCESS,
  projectId,
  credits
});

export const purchaseOrderError = (
  projectId,
  orderId,
  paymentMethodId,
  error
) => ({
  type: constants.PURCHASE_ORDER_ERROR,
  projectId,
  orderId,
  paymentMethodId,
  error
});
